/** @format */

import PropTypes from 'prop-types';
import { withAuthGuard } from 'src/hocs/with-auth-guard';
import { useAuth } from 'src/hooks/use-auth';
import { useSettings } from 'src/hooks/use-settings';
import AccountComplete from 'src/modals/account_complete';
import AccountPasswordReset from 'src/modals/account_password_reset';
import { ZaloPermission } from 'src/modals/zalo_request_permission';
import { useSections } from './config';
import { NormalLayout } from './normal-layout';

export const Layout = withAuthGuard((props) => {
  const settings = useSettings();
  const sections = useSections();

  const {
    user: { setupCompleted, isAcceptResetPassword }
  } = useAuth();

  return (
    <>
      {!setupCompleted && <AccountComplete />}
      {isAcceptResetPassword && <AccountPasswordReset />}
      <ZaloPermission />
      <NormalLayout sections={sections} navColor={settings.navColor} {...props} />
    </>
  );
});

Layout.propTypes = {
  children: PropTypes.node
};
